export default __webpack_public_path__ + "a6065509bfdaf2f034fdcdb06596d080.png";